
function isEligibleToShow(eventKey, storeDetails, orgDetails) {
    let eligibleToShow = false;
    if (!['grn', 'requisitions'].includes(eventKey) && storeDetails.store_type === null && !storeDetails.is_procurement_hub) {
        eligibleToShow = true;
    } else {
        if (storeDetails.store_type === 'MAIN') {
            const hideEvents = ['orders', 'digital_menu_orders', 'open_business_day', 'monthly_targets', 'business_registers', 'product_label', 'add_on_groups', 'restaurant', 'kitchen_display', 'tables', 'waiter_display', 'restaurant_menu', 'operating_hours', 'billing_counters', 'variant_options', 'kitchen_displays', 'bill_posting_settings', 'night_audit_report', 'billing_counter_dashboard', 'best_seller_report', 'day_wise_sale_report', 'change_in_transaction', 'coupons']

            const hideEventsForReports = ['sales_tax_report', 'mis_report', 'daily_consumption_report', 'billing_counter_report', 'f&b_sales_summary_report', 'order_report', 'customer_report', 'tax_code_report', 'discount_code_report', 'kot_bot_report']

            const mergeHideEvents = [...hideEvents, ...hideEventsForReports]
            // console.log("mergeHideEvents===",mergeHideEvents)
            if (!mergeHideEvents.includes(eventKey)) {
                eligibleToShow = true
            }
        } else if (storeDetails.store_type === 'BRANCH') {
            if (orgDetails.allow_main_store) {
                if (storeDetails.is_procurement_hub) {
                    if (!storeDetails.self_procurement) {
                        const hideEvents = ['digital_menu_orders', 'open_business_day', 'purchase_orders', 'grn', 'quotations', 'suppliers', 'supplier', 'product_label', 'restaurant', 'add_on_groups', 'billing_counter_dashboard', 'kitchen_displays', 'variant_options', 'category_report', 'stock_quantity_alert', 'store_stock_chart', 'product_audit_history', 'product_audit_trail', 'change_in_transaction', 'night_audit_report', 'pms_sync_report', 'supplier_ledger']

                        const hideEventsForReports = ['purchase_order_report', 'quotation_report', 'supplier_report', 'grn_report', 'stock_transfer_report']

                        const mergeHideEvents = [...hideEvents, ...hideEventsForReports]
                        if (!mergeHideEvents.includes(eventKey)) {
                            eligibleToShow = true
                        }
                    } else {
                        const hideEvents = ['open_business_day', 'night_audit_report']

                        const hideEventsForReports = []

                        const mergeHideEvents = [...hideEvents, ...hideEventsForReports]
                        if (!mergeHideEvents.includes(eventKey)) {
                            eligibleToShow = true
                        }
                    }
                } else {
                    const hideEvents = ['purchase_orders', 'grn']

                    const hideEventsForReports = ['purchase_order_report', 'supplier_report', 'grn_report']
                    const mergeHideEvents = [...hideEvents, ...hideEventsForReports]
                    if (!mergeHideEvents.includes(eventKey)) {
                        eligibleToShow = true
                    }
                }
            } else {
                if (storeDetails.is_procurement_hub) {
                    const hideEvents = ['orders', 'digital_menu_orders', 'open_business_day', 'billing_counter_dashboard', 'monthly_targets', 'business_registers', 'product_label', 'add_on_groups', 'best_seller_report', 'day_wise_sale_report', 'category_report', 'change_in_transaction', 'night_audit_report', 'restaurant', 'kitchen_display', 'tables', 'waiter_display', 'restaurant_menu', 'operating_hours', 'billing_counters', 'kitchen_displays', 'variant_options', 'coupons']

                    const hideEventsForReports = ['sale_tax_report', 'mis_report', 'daily_consumption_report', 'billing_counter_report', 'product_report', 'f&b_sales_summary_report', 'order_report', 'customer_report', 'kot_bot_report']
                    const mergeHideEvents = [...hideEvents, ...hideEventsForReports]

                    if (!mergeHideEvents.includes(eventKey)) {
                        eligibleToShow = true
                    }
                } else {
                    const hideEvents = ['requisitions', 'grn']
                    if (!hideEvents.includes(eventKey)) {
                        eligibleToShow = true
                    }
                }
            }
        } else if (storeDetails.store_type === 'COST_CENTER' && !['purchase_orders', 'grn'].includes(eventKey)) {
            if (storeDetails.can_sell || storeDetails.can_sell === 1) {
                const hideEvents = ['suppliers', 'supplier',]
                const hideEventsForReports = ['purchase_order_report', 'supplier_report', 'grn_report']
                const mergeHideEvents = [...hideEvents, ...hideEventsForReports]

                if (!mergeHideEvents.includes(eventKey)) {
                    eligibleToShow = true
                }
            } else {
                const hideEvents = ['invoices', 'orders', 'digital_menu_orders', 'transactions', 'customers', 'quotations', 'suppliers', 'supplier', 'best_seller_report', 'day_wise_sale_report', 'change_in_transaction', 'night_audit_report', 'restaurant', 'kitchen_display', 'tables', 'waiter_display', 'restaurant_menu', 'operating_hours', 'billing_counters', 'kitchen_displays', 'payment_methods', 'open_business_day', 'coupons']

                const hideEventsForReports = ['sales_tax_report', 'mis_report', 'daily_consumption_report', 'billing_counter_report', 'f&b_sales_summary_report', 'order_report', 'purchase_order_report', 'customer_report', 'invoice_report', 'quotation_report', 'transaction_report', 'supplier_report', 'kot_bot_report', 'requisition_report', 'grn_report']
                const mergeHideEvents = [...hideEvents, ...hideEventsForReports]

                if (!mergeHideEvents.includes(eventKey)) {
                    eligibleToShow = true
                }
            }
        }
    }
    return eligibleToShow;
};

export default isEligibleToShow;